import { Link } from "react-router-dom";
import { HelpCircle, Mail, MailWarning, Megaphone, Newspaper, Package, Wrench } from "lucide-react";
import { useContent } from "@/lib/hooks";

const CARDS = [
  { key: "packages", label: "Paketler", icon: Package, to: "/admin/content/packages" },
  { key: "services", label: "Hizmetler", icon: Wrench, to: "/admin/content/services" },
  { key: "campaigns", label: "Kampanyalar", icon: Megaphone, to: "/admin/content/campaigns" },
  { key: "faqs", label: "SSS", icon: HelpCircle, to: "/admin/content/faqs" },
  { key: "posts", label: "Blog Yazıları", icon: Newspaper, to: "/admin/content/posts" },
  { key: "messages", label: "Mesajlar", icon: Mail, to: "/admin/messages" },
];

export default function Dashboard() {
  const { data: stats = {} } = useContent("/admin/stats");

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-heading text-2xl font-black tracking-tight text-zinc-950">Genel Bakış</h1>
      <p className="mt-1 text-sm text-zinc-500">Web sitesi içerik yönetim paneline hoş geldiniz.</p>

      {stats.unread_messages > 0 && (
        <Link
          to="/admin/messages"
          data-testid="admin-unread-banner"
          className="mt-6 flex items-center gap-3 rounded-xl border border-amber-300 bg-amber-50 px-5 py-4 text-sm font-medium text-amber-800 transition-colors hover:bg-amber-100"
        >
          <MailWarning className="h-5 w-5" />
          {stats.unread_messages} okunmamış mesajınız var.
        </Link>
      )}

      <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {CARDS.map((card) => (
          <Link
            key={card.key}
            to={card.to}
            data-testid={`admin-stat-${card.key}`}
            className="group rounded-2xl border border-zinc-200 bg-white p-6 transition-all duration-200 hover:border-[#1A4BFF] hover:shadow-md"
          >
            <div className="flex items-center justify-between">
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#EEF2FF] text-[#1A4BFF] transition-colors group-hover:bg-[#1A4BFF] group-hover:text-white">
                <card.icon className="h-5 w-5" />
              </span>
              <span className="font-heading text-3xl font-black text-zinc-950">{stats[card.key] ?? "—"}</span>
            </div>
            <p className="mt-4 text-sm font-bold text-zinc-700">{card.label}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
